module.exports = __webpack_public_path__ + "img/icon-xueyuan-logo.7853f65a.png";